import { render } from "./NewBox.vue?vue&type=template&id=5146544f&scoped=true"
import script from "./NewBox.vue?vue&type=script&lang=js"
export * from "./NewBox.vue?vue&type=script&lang=js"

import "./NewBox.vue?vue&type=style&index=0&id=5146544f&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5146544f"]])

export default __exports__